import { EnterpriseOptionType } from '@app/core/interfaces/enterprise-option-type';

export interface EnterpriseOptionDefinition {
  id?: number; // Option[Int] = None
  name: EnterpriseOptionType; // String
  description?: string; // Option[String] = None
  category?: OptionCategory; // Option[String] = None
  level: string; // String // OptionLevel.Value = OptionLevel.ENTERPRISE
  optionType: OptionType; // String // OptionType.Value = OptionType.COUNT
  virtual: boolean; // Boolean
  licensed: boolean; // Boolean
  createdOn: string; // DateTime = DateTime.now()
  updatedOn: string; // DateTime = DateTime.now()
}

export enum OptionType {
  BOOL = 'BOOL',
  COUNT = 'COUNT',
}

export enum OptionCategory {
  _Hidden = '_Hidden',
  General = 'General',
  CallCenter = 'CallCenter',
  Collaboration = 'Collaboration',
  Integration = 'Integration',
  Recording = 'Recording',
  Service = 'Service',
  Softclient = 'Softclient',
  UserFeature = 'UserFeature',
}
